import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

import TicketCard from 'src/common/components/styled/TicketCard';
import { ticketCardGridItemSx } from 'src/common/styles/ticketCardStyles';
import { minutesToHours } from 'src/helpers/dateTimeFormatters';

interface Props {
  totalParticipants: number;
  distanceCount: number;
  fastestTime: number;
  maleCount: number;
  femaleCount: number;
}

export default function InsightsKpiCards({
  totalParticipants,
  distanceCount,
  fastestTime,
  maleCount,
  femaleCount,
}: Props) {
  const { t } = useTranslation();
  const totalGender = maleCount + femaleCount;
  const malePct = totalGender > 0 ? Math.round((maleCount / totalGender) * 100) : 0;
  const femalePct = totalGender > 0 ? Math.round((femaleCount / totalGender) * 100) : 0;

  const items = [
    {
      label: t('insights.kpi.finishers'),
      value: String(totalParticipants),
    },
    {
      label: t('insights.kpi.distances'),
      value: String(distanceCount),
    },
    {
      label: t('insights.kpi.fastest'),
      value: fastestTime > 0 ? minutesToHours(fastestTime, t) : '-',
    },
    {
      label: t('insights.kpi.genderSplit'),
      value: t('insights.kpi.genderSplitValue', { male: malePct, female: femalePct }),
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3, overflow: 'visible' }}>
      {items.map(item => (
        <Grid key={item.label} size={{ xs: 6, sm: 3 }} sx={ticketCardGridItemSx}>
          <TicketCard
            eyebrow={item.label}
            title={item.value}
            innerSx={{ mt: 1.5 }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
